// extracted by mini-css-extract-plugin
module.exports = {"commentWrapper":"Comment_commentWrapper__1Uwg_"};